/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var OverrideType;

(function (OverrideType) {
  OverrideType["OVERALL"] = "overall";
  OverrideType["DIFFERENCE"] = "difference";
  OverrideType["TOTAL"] = "total";
})(OverrideType || (OverrideType = {}));